import { Example } from './helpers/model';
import { DefaultButton } from '@inmoment/the-kitchen';

// name the export <ReactComponentName_examples>
export const DefaultButton_examples: Example<Parameters<typeof DefaultButton>[0]>[] = [
  {
    name: 'Fill',
    // props can be strings, numbers, or objects. Anything else will need to be custom
    props: {
      text: 'Save',
    },
    // angular: "my custom code" // If you want to use custom code for angular or react
  },
  {
    name: 'Disabled',
    props: {
      text: 'save',
      disabled: true,
    },
  },
  {
    name: 'Disabled With Tooltip',
    props: {
      text: 'save',
      tooltip: { text: 'Tool Tip on Hover', direction: 12 },
      disabled: true,
      tooltipDisplayOnDisabled: true,
    },
  },
  {
    name: 'Tooltip',
    props: {
      text: 'save',
      tooltip: { text: 'Tool Tip on Hover', direction: 12 },
    },
  },
  {
    name: 'Double Icon',
    props: {
      text: 'save',
      iconLeft: 'arrow_left',
      iconRight: 'arrow_right',
    },
  },
  {
    name: 'Icon Left',
    props: {
      text: 'save',
      iconLeft: 'arrow_left',
    },
  },
  {
    name: 'Icon Right',
    props: {
      text: 'save',
      iconRight: 'arrow_right',
    },
  },
  {
    name: 'With Shadow',
    props: {
      text: 'save',
      hasShadows: true,
    },
  },
  {
    name: 'No-Fill',
    props: {
      text: 'save',
      fill: 'no-fill',
    },
  },
  {
    name: 'Outline',
    props: {
      text: 'save',
      fill: 'outline',
    },
  },
  //Text buttons need a background around the component
  {
    name: 'Text',
    props: {
      text: 'save',
      fill: 'text',
    },
  },
  //probably want to add a link with arrows
  {
    name: 'Link',
    props: {
      text: 'save',
      fill: 'link',
    },
  },
  {
    name: 'Link with icon',
    props: {
      text: 'save',
      fill: 'link',
      iconRight: 'arrow_right',
    },
  },
  {
    name: 'Clickable Icon',
    description: 'View the click events in the console',
    props: {
      text: '<b>Tag:</b> Hello World',
      iconRight: 'cancel_circle',
      isIconRightButton: true,
      onIconClick: console.log,
    },
    angular: `<xi-default-button
    text="<b>Tag:</b> Hello World"
    iconRight="cancel_circle"
    [isIconRightButton]="true"
    (onIconClick)="myOnClickFunction"
  >
</xi-default-button>`,
    react: `<DefaultButton
    text={"<b>Tag:</b> Hello World"}
    iconRight={"cancel_circle"}
    isIconRightButton={true}
    onIconClick={myOnClickFunction}
  >
</DefaultButton>`,
  },
  //
  {
    name: 'Without Animation',
    props: {
      text: 'Hello World',
      hasAnimation: false,
    },
  },
  {
    name: 'Change Color',
    props: {
      text: 'Hello World',
      color: 'EX',
    },
  },
  {
    name: 'Stretch - Responsive',
    props: {
      text: 'Hello World',
      stretch: true,
    },
    slotStyle: {
      display: 'block',
    },
  },
  {
    name: 'Stretch with alignment',
    props: {
      text: 'Hello World',
      stretch: true,
      iconRight: 'ab_testing',
      textIconAlignment: 'space-between',
    },
    slotStyle: {
      display: 'block',
    },
  },
  {
    name: 'Stretch with alignment - dual icon',
    props: {
      text: 'Hello World',
      stretch: true,
      iconLeft: 'lodge',
      iconRight: 'ab_testing',
      textIconAlignment: 'space-between',
    },
    slotStyle: {
      display: 'block',
    },
  },
  {
    name: 'Stretch with alignment - centered text',
    props: {
      text: 'Hello World',
      stretch: true,
      iconLeft: 'no_icon',
      iconRight: 'ab_testing',
      textIconAlignment: 'space-between',
    },
    slotStyle: {
      display: 'block',
    },
  },
  {
    name: 'Stretch with alignment - Right',
    props: {
      text: 'Hello World',
      stretch: true,
      iconRight: 'meatball',
      textIconAlignment: 'right',
    },
    slotStyle: {
      display: 'block',
    },
  },
  {
    name: 'Stretch with alignment - Left',
    props: {
      text: 'Hello World',
      stretch: true,
      iconRight: 'link',
      textIconAlignment: 'left',
    },
    slotStyle: {
      display: 'block',
    },
  },
  {
    name: 'Size - Small',
    props: {
      text: 'Hello World',
      buttonSize: 'small',
    },
  },
  {
    name: 'Size - Large',
    props: {
      text: 'Hello World',
      buttonSize: 'large',
    },
  },
  {
    name: 'Size - XXLarge',
    props: {
      text: 'Hello World',
      buttonSize: 'xxlarge',
    },
  },
  {
    name: 'Sentiment',
    props: {
      text: 'Hello World',
      sentimentIndicator: 'positive',
    },
  },
  {
    name: 'Tone - light',
    props: {
      text: 'Hello World',
      tone: 'light',
    },
  },
  {
    name: 'Status - Error',
    props: {
      text: 'Hello World',
      status: 'error',
    },
  },
];
